<template>
    <div class="person_box animate__animated animate__fadeIn">
        <div class="person">
            <div class="search_box">
                <div class="box_line">
                    <div class="line_input">
                        <div class="input_title">人员姓名</div>
                        <input type="text" class="input_box" placeholder="请输入人员姓名" v-model="searchName"/>
                    </div>
                    <div class="line_input">
                        <div class="input_title">卡号</div>
                        <input type="text" class="input_box" placeholder="请输入卡号" v-model="searchCardNo"/>
                    </div>
                    <div class="line_input">
                        <div class="input_title">所属班组</div>
                        <input type="text" class="input_box" placeholder="请输入所属班组" v-model="searchDepartment"/>
                    </div>
                    <div class="line_input">
                        <div class="input_title">所属工种</div>
                        <input type="text" class="input_box" placeholder="请输入所属工种" v-model="searchPosition"/>
                    </div>
                    <div class="line_input">
                        <div class="input_title">身份证号</div>
                        <input type="text" class="input_box" placeholder="请输入身份证号" v-model="searchId"/>
                    </div>
                    <div class="line_input">
                        <div class="input_title">人员状态</div>
                        <el-select size="small" class="select_box" v-model="searchStatus" :popper-append-to-body="false"
                                   filterable placeholder="请选择" style="border-radius: 0;">
                            <el-option label="请选择" value></el-option>
                            <el-option label="已进场" value="1">已进场</el-option>
                            <el-option label="已离场" value="0">已离场</el-option>
                        </el-select>
                    </div>
                </div>
                <div class="box_line">
                    <div class="line_input">
                        <div class="input_title">在岗状态</div>
                        <el-select size="small" class="select_box" v-model="searchOnDutyStatus" :popper-append-to-body="false"
                            filterable placeholder="全部" style="border-radius: 0;">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="在岗" value="1">在岗</el-option>
                            <el-option label="离岗" value="0">离岗</el-option>
                        </el-select>
                    </div>
                    <div class="line_input">
                        <div class="input_title">下发状态</div>
                        <el-select size="small" v-model="searchTaskState" :popper-append-to-body="false" filterable
                                   placeholder="全部">
                            <el-option label="全部" :value="null"></el-option>
                            <el-option label="未下发" :value="4"></el-option>
                            <el-option label="正在执行" :value="0"></el-option>
                            <el-option label="全部成功" :value="1"></el-option>
                            <el-option label="部分成功" :value="2"></el-option>
                            <el-option label="全部失败" :value="3"></el-option>
                        </el-select>
                    </div>
                    <div class="line_input">
                        <div class="input_title">删除状态</div>
                        <el-select size="small" v-model="searchDelete" :popper-append-to-body="false" filterable
                                   placeholder="请选择" style="border-radius: 0; vertical-align: bottom">
                            <el-option label="已删除" value="1">已删除</el-option>
                            <el-option label="未删除" value="0">未删除</el-option>
                        </el-select>
                    </div>
                    <div class="line_input">
                        <div class="input_title">创建时间</div>
                        <el-date-picker
                            size="small"
                            v-model="searchCreateDate"
                            type="datetimerange"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            style="width: 392px;"
                        ></el-date-picker>
                    </div>
                    <div class="search-btn" @click="fnSearch"><span>搜索</span></div>
                </div>
                <div class="box_line">
                    <!-- 添加人员 -->
                    <div class="add_person" @click="fnOpenAddOrEdit('add')"></div>
                    <!-- 下发人员至人脸设备 -->
                    <div class="to_face" @click="fnSendPerson"></div>
                    <!-- 下发人员至客户端 -->
                    <div class="to_custom" @click="fnSendClient"></div>
                    <!-- 导出Excel -->
                    <div class="to_export" @click="fnExportExcel"></div>
                    <!-- 推荐使用小程序工人自主录入 -->
                    <!-- <div class="to_weixin" @click="fnShowProjectCode"></div> -->
                    <!-- 上传人员至融创 -->
                    <div class="to_upload" v-if="isShowUploadBtn" @click="showUploadRc=true"></div>
                </div>
            </div>
            <div class="cont_list">
                <div class="list_title">
                    <div class="title_item">
                        <div class="select" @click="fnSelectAll()" :class="selectAll ? 'active' : ''"></div>
                    </div>
                    <div class="title_item">姓名</div>
                    <div class="title_item">可见光照</div>

                    <div class="title_item">性别</div>
                    <div class="title_item">身份证号</div>
                    <div class="title_item">班组</div>
                    <div class="title_item">工种</div>
                    <div class="title_item">联系电话</div>
                    <div class="title_item">上传状态</div>
                    <div class="title_item">下发状态</div>
                    <div class="title_item">状态</div>
                    <div class="title_item">创建时间</div>
                    <div class="title_item">操作</div>
                </div>
                <div class="list_boxes">
                    <div class="list_box">
                        <div v-if="tableData">
                            <div class="box_line" v-for="(item, index) in tableData" :key="index">
                                <div class="list_item">
                                    <div class="select" @click="fnHandleCheckedChange(index)"
                                         :class="item.selected ? 'active' : ''"></div>
                                </div>
                                <div class="list_item">{{ item.name }}</div>
                                <div class="list_item"><img
                                    :src="item.photo || 'http://cqxtkj.oss-cn-chengdu.aliyuncs.com/image/40fd31b9434de0d6cc965f1c2b475368.jpg'"/>
                                </div>

                                <div class="list_item">{{ item.sex == '1' ? '男' : '女' }}</div>
                                <div class="list_item">{{ item.idcard }}</div>
                                <div class="list_item" :title="fnTeamFormat(item.department)">
                                    <span>{{ fnTeamFormat(item.department) }}</span></div>
                                <div class="list_item" :title="fnTeamFormat(item.position)">
                                    <span>{{ fnTeamFormat(item.position) }}</span></div>
                                <div class="list_item">{{ item.phone }}</div>
                                <div class="list_item" :title="item.extend | fnUploadObjToText">
                                    <span>{{ item.extend | fnUploadObjToText }}</span></div>
                                <div class="list_item">
                                    <el-popover placement="top-start" width="600" trigger="hover">
                                        <el-table :data="APP.fnAutoSendPersonState(item.task_details,faceList)" stripe
                                                  border style="width: 100%;" height="240">
                                            <el-table-column label="设备名" width="100" align="center">
                                                <template slot-scope="scope">
                                                    <div
                                                        :title="scope.row.model +'【'+scope.row.record_type +'】：'+ scope.row.sn">
                                                        {{ scope.row.name }}
                                                    </div>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="lanIP" label="LANIP" align="center" width="120">
                                            </el-table-column>
                                            <el-table-column prop="type" label="类型" width="80"
                                                             filter-placement="bottom-end" align="center">
                                                <template slot-scope="scope">
                                                    <el-tag v-if="scope.row.type == 0">写入</el-tag>
                                                    <el-tag v-else type="danger">清除</el-tag>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="status" label="状态" width="100"
                                                             filter-placement="bottom-end" align="center">
                                                <template slot-scope="scope">
                                                    <el-tag v-if="scope.row.status == 0">正在执行</el-tag>
                                                    <el-tag v-else-if="scope.row.status == 1" type="success">下发成功
                                                    </el-tag>
                                                    <el-tag v-else type="danger" style="cursor: pointer;"
                                                            title="下发失败，重试请确认错误情况已处理"
                                                            @click="APP.fnSendPersonToAccess(THAT,item,scope.row)">点击重试
                                                    </el-tag>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="details" label="详情" align="center">
                                            </el-table-column>
                                        </el-table>
                                        <div slot="reference" style="">
                                            <span v-if="item.task_state === null">未下发</span>
                                            <span v-else-if="item.task_state == 0" style="color: #409EFF">正在执行</span>
                                            <span v-else-if="item.task_state == 1" style="color: #67c23a">全部成功</span>
                                            <span v-else-if="item.task_state == 2" style="color: #E6A23C">部分成功</span>
                                            <span v-else style="color: #F56C6C">全部失败</span>
                                        </div>
                                    </el-popover>
                                </div>

                                <div class="list_item">
                                    <div :style="item.status ? 'color: #89d340;' : 'color: #df7475;'">
                                        {{ item.status ? '已进场' : '已离场' }}
                                    </div>
                                    <div v-if="item.status">-
                                        <span :style="item.on_duty_status ? 'color: #89d340;' : 'color: #df7475;'">
                                            {{ item.on_duty_status ? '在岗' : '离岗' }}
                                        </span>
                                    </div>
                                </div>
                                
                                <div class="list_item">{{ item.create_at }}</div>
                                <div class="list_item">
                                    <div v-if="item.is_deleted == 0">
                                        <button class="item_btn blue" @click="fnOpenAddOrEdit(item)"><span>编辑</span>
                                        </button>
                                        <button class="item_btn" :class="item.status?'yellow':'green'"
                                                @click="fnChangeStatus(item)">
                                            <span>{{ item.status ? '离场' : '进场' }}</span>
                                        </button>
                                        <button class="item_btn" :class="item.on_duty_status ? 'yellow' : 'green'"
                                            @click="fnChangeOnDutyStatus(item)">
                                            <span>{{ item.on_duty_status ? '离岗' : '在岗' }}</span>
                                        </button>
                                        <button class="item_btn red" @click="fnDelete(item)"><span>删除</span></button>
                                    </div>
                                    <div v-if="item.is_deleted">
                                        <button class="item_btn blue" @click="fnRecovery(item)"><span>恢复</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="cont_page">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-sizes="pageSizes"
                    :page-size="pageSize"
                    :current-page="currentPage"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageTotal"
                />
            </div>
            <div v-if="dialogFormVisible">
                <AddPerson :editInfo="editInfo"></AddPerson>
            </div>
            <div class="dialog_choose" v-if="showSelectFace">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="选择人脸设备" top="20vh"
                           center :visible.sync="showSelectFace">
                    <div class="cont_list">
                        <div class="list_title">
                            <div class="title_item">
                                <div class="select" @click="fnSelectAllAccess()"
                                     :class="selectAllAccess ? 'active' : ''"></div>
                            </div>
                            <div class="title_item">设备名</div>
                            <div class="title_item">LANIP</div>
                            <div class="title_item">方向</div>
                            <div class="title_item">状态</div>
                        </div>
                        <div class="list_boxes">
                            <div class="list_box">
                                <div v-if="faceList">
                                    <div class="box_line" v-for="(item, index) in faceList" :key="index">
                                        <div class="list_item">
                                            <div class="select" @click="fnHandleCheckedAccessChange(index,item)"
                                                 :class="item.selected ? 'active' : ''"></div>
                                        </div>
                                        <div class="list_item" :title="item.sn">{{ item.name }}</div>
                                        <div class="list_item">{{ item.lanIP }}</div>
                                        <div class="list_item">
                                            <span v-if="item.record_type == 0">无效</span>
                                            <span v-else-if="item.record_type == 1">进门</span>
                                            <span v-else>出门</span>
                                        </div>
                                        <div class="list_item">{{ fnOnlineStatusText(item.heartbeatTime).text }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div slot="footer" class="dialog-footer" align="center">
                        <div class="btn_line">
                            <div class="search-btn red" @click="showSelectFace = false"><span>取消</span></div>
                            <div class="search-btn" @click="fnSendPersonToAccess"><span>下发</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>
            <div class="dialog_toAccessError" v-if="showErrorDown">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="人员下发提示"
                           :visible.sync="showErrorDown" center>
                    <div>去任务中心查看详细信息</div>
                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <div class="search-btn red w-80" @click="showErrorDown = false"><span>取消</span></div>
                            <div class="search-btn w-80" @click="goToWork"><span>查看详情</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>
            <!-- 查看二维码弹出层 -->
            <div class="dialog_perXcx" v-if="showXcx">
                <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="项目二维码"
                           :visible.sync="showXcx" center>
                    <img :src="xcxQRcodeUrl"/>
                    <div slot="footer" class="dialog-footer">
                        <div class="btn_line">
                            <div class="search-btn red" @click="showXcx = false"><span>关闭</span></div>
                        </div>
                    </div>
                </el-dialog>
            </div>
            <!-- 融创上传人员 -->
            <div v-if="showUploadRc">
                <UploadRC></UploadRC>
            </div>
        </div>
    </div>
</template>

<script>
import APP from '@/utils/base';
import request from '@/utils/request';
import Cookies from 'js-cookie';
import AddPerson from './components/AddPerson';
import {getUserInfo} from '@/utils/auth';
import UploadRC from '../uploadRC.vue'
import sha1 from 'js-sha1';

export default {
    components: {
        AddPerson,
        UploadRC
    },
    data() {
        return {
            APP: APP,
            THAT: this,
            selectAll: false, // 是否全选
            selectAllAccess: false, // 是否全选设备
            // 分页
            pageSize: APP.PAGE.LIMIT,
            pageSizes: APP.PAGE.SIZE_OPTION,
            currentPage: APP.PAGE.SKIP_PAGE,
            pageTotal: 0,
            // 搜索
            userInfo: null, // 登录账户信息
            searchName: '', // 人员姓名搜索
            searchCardNo: '', // 卡号搜索
            searchDepartment: '', // 班组搜索
            searchPosition: '', // 工种搜索
            searchId: '', // 身份证号搜索
            searchTaskState: null, // 搜索人员任务状态
                searchStatus: '', // 人员状态搜索
                searchOnDutyStatus:'',
            searchDelete: '0', // 人员是否删除搜索
            searchCreateDate: '', // 创建时间搜索
            serchtime: '', //搜索时间格式化
            // 人员
            tableData: [], // 人员列表数据
            // 弹窗
            dialogFormVisible: false, // 添加、编辑人员弹窗
            showSelectFace: false, // 选择人脸设备弹窗
            showErrorDown: false, // 人员下发失败弹窗
            showXcx: false, // 二维码弹窗
            // 数据
            needSendPersonnel: [], // 需要下发的人员
            selectedSendPersonnel: [], // 已选择需要下发的人员列表
            selectAccess: [], // 选中的设备
            faceList: [], // 人脸设备列表
            isEdit: false, // 是否是编辑状态
            editInfo: null, // 人员编辑信息
            xcxQRcodeUrl: '', // 小程序二维码
            isAllSendPerson: false,// 下发全部人员
            // 上传融创
            showUploadRc: false,// 上传人员至融创 组件弹窗
            isShowUploadBtn: false,
        };
    },
    created() {
        this.userInfo = getUserInfo();
        let _region = this.userInfo.region
        if (_region.indexOf('21') != -1) {
            this.isShowUploadBtn = true
        }
        this.fnInit();
    },
    methods: {
        // 初始化
            fnInit() {
                this.fnGetaccessEqpt()
                this.fnGetPersonnel({
                page: this.currentPage,
                size: this.pageSize,
                is_deleted: this.searchDelete
            }, res => {
                let _arr = res.data.query;
                if (_arr.length > 0) {
                    for (var i in _arr) {
                        _arr[i].selected = false;
                    }
                    this.tableData = _arr;
                } else {
                    this.tableData = []
                    this.$message.warning("暂无数据");
                }
                this.pageTotal = res.data.count;
            });
        },
        // 选择下发的设备
        // 全选
        fnSelectAllAccess() {
            let _arr = []
            for (var i in this.faceList) {
                let _select = this.fnSelectable(this.faceList[i], i)
                if (_select) {
                    _arr.push(this.faceList[i])
                    this.faceList[i].selected = true
                } else {
                    this.faceList[i].selected = false
                }
            }
            if (this.faceList.length != _arr.length) {
                this.$message.error("不在线的设备不能选择！");
            }
            this.selectAccess = _arr
        },
        // 单个选择
        fnHandleCheckedAccessChange(_index, _item) {
            let isSelect = this.fnSelectable(_item, _index);
            if (!isSelect) {
                this.$message.error("此设备不在线！");
                return
            }
            for (let i = 0; i < this.faceList.length; i++) {
                if (i == _index) {
                    this.faceList[i].selected = !this.faceList[i].selected
                }
            }
            let _arr = []
            for (let j = 0; j < this.faceList.length; j++) {
                if (this.faceList[j].selected) {
                    _arr.push(this.faceList[j])
                }
            }
            if (_arr.length == this.faceList.length) {
                this.selectAllAccess = true
            } else {
                this.selectAllAccess = false
            }
            this.selectAccess = _arr
        },
        // 关闭 添加/编辑弹窗
        fnCloseAddOrEdit() {
            this.dialogFormVisible = false;
            this.fnInit();
        },
        // 分页选择
        handleSizeChange(val) {
            this.pageSize = val;
            this.fnSearch();
        },
        // 分页跳转
        handleCurrentChange(val) {
            this.currentPage = val;
            this.fnSearch();
        },
        // 获取人员列表
        fnGetPersonnel(_obj, _cb) {
            request({
                url: 'personnel/getPersonnel',
                method: 'GET',
                params: _obj
            }).then(res => {
                _cb && _cb(res);
            })
                .catch(err => {
                    this.$message.error(err.data);
                });
        },
        // 搜索
        fnSearch(_isInit) {
                this.fnGetaccessEqpt()
            if (this.searchCreateDate) {
                this.serchtime = this.searchCreateDate[0] + ',' + this.searchCreateDate[1];
            } else {
                this.serchtime = '';
            }
            this.fnGetPersonnel({
                page: _isInit ? 1 : this.currentPage,
                size: this.pageSize,
                name: this.searchName,
                card_no: this.searchCardNo,
                department: this.searchDepartment,
                position: this.searchPosition,
                idcard: this.searchId,
                is_deleted: this.searchDelete,
                status: this.searchStatus,
                on_duty_status: this.searchOnDutyStatus,
                        task_state: this.searchTaskState,
                create_at: this.serchtime
            }, res => {
                let _arr = res.data.query;
                if (_arr.length > 0) {
                    for (var i in _arr) {
                        _arr[i].selected = false;
                    }
                    this.tableData = _arr;
                } else {
                    this.tableData = []
                    this.$message.warning("暂无搜索数据");
                }
                this.pageTotal = res.data.count;
            });
        },
        // 班组格式化 去除 #
        fnTeamFormat(_name) {
            return APP.fnTeamFormat(_name);
        },
        // 添加人员
        fnOpenAddOrEdit(_data) {
            if (_data == 'add') {
                _data = '';
            }
            this.editInfo = _data;
            this.dialogFormVisible = !this.dialogFormVisible;
        },
        // 修改人员在岗状态
        fnChangeOnDutyStatus(_data) {
            request({
                    url: 'personnel/changeOnDutyStatus',
                    method: 'POST',
                    data: {
                        on_duty_status:  _data.on_duty_status ? 0 : 1,
                        personnel_id: _data.id
                    }
                })
                .then(res => {
                    this.$message.success(res.data);
                    this.fnSearch();
                })
                .catch(err => {
                    this.$message.error(err.data);
                });
        },
        // 修改人员状态
        fnChangeStatus(_data) {
            let _personnel_id = _data.id;
            let _status = _data.status ? 0 : 1;
            request({
                url: 'personnel/changeStatus',
                method: 'POST',
                data: {
                    status: _status,
                    personnel_id: _personnel_id
                }
            }).then(res => {
                this.$message.success(res.data);
                APP.fnSendPersonToAllAccess(_data, this.faceList)
                this.fnSearch();
            })
                .catch(err => {
                    this.$message.error(err.data);
                });
        },
        // 删除人员
        fnDelete(_data) {
            request({
                url: 'personnel/deletePersonnel',
                method: 'POST',
                data: {
                    id: _data.id
                }
            }).then(res => {
                this.$message.success(res.data);
                APP.fnSendPersonToAllAccess(_data, this.faceList)
                this.fnSearch();
            })
                .catch(err => {
                    this.$message.error(err.data);
                });
        },
        // 恢复
        fnRecovery(item) {
            let _personnelInfo = {
                id: item.id,
                idcard_sha1: item.idcard_sha1,
                is_deleted: 0
            }
            request({
                url: 'personnel/addEditPersonnel',
                method: 'POST',
                data: {
                    personnel_info: JSON.stringify(_personnelInfo)
                }
            })
                .then(res => {
                    this.$message.success(res.data);
                    this.fnInit()
                })
                .catch(err => {
                    this.$message.error(err.data);
                });
        },
        // 判断人脸设备是否可选
        fnSelectable(row, index) {
            // if (APP.fnOnlineStatusText(row.heartbeatTime).status) {
            // 	return true;
            // } else {
            // 	return false;
            // }
            return APP.fnOnlineStatusText(row.heartbeatTime).status ? true : false
        },
        fnOnlineStatusText(_heartbeatTime) {
            return APP.fnOnlineStatusText(_heartbeatTime);
        },
        // 下发人员至人脸设备
        fnSendPerson() {
            if (!this.selectedSendPersonnel.length) {
                this.$message.warning('请选择需要下发至设备的人员.');
                return;
            }
            this.needSendPersonnel = [];
            let _data = this.selectedSendPersonnel;
            for (let _key in _data) {
                this.needSendPersonnel.push({
                    personnel_id: _data[_key].id,
                    name: _data[_key].name
                });
            }
            if (this.selectedSendPersonnel.length != this.pageSize) {
                this.showSelectFace = true;
                this.fnGetaccessEqpt();
                return;
            }
            this.$confirm('是否下发全部人员?', '提示', {
                distinguishCancelAndClose: true,
                confirmButtonText: '下发当前页人员',
                cancelButtonText: '下发全部人员(每天只能下发一次)'
            }).then(() => {
                this.isAllSendPerson = false;
                this.showSelectFace = true;
                this.fnGetaccessEqpt();
            })
                .catch(action => {
                    if (action === 'cancel') {
                        if (Cookies.get('isAllSendPerson')) {
                            // 当天是否已经下发过全部人员
                            this.$message.warning('今日下发全部人员次数已用完，如需下发全部人员请联系管理员');
                            return;
                        }
                        request({
                            url: 'personnel/getAllPersonnel',
                            method: 'GET'
                        }).then(res => {
                            this.needSendPersonnel = [];
                            for (let _key in res.data) {
                                this.needSendPersonnel.push({
                                    personnel_id: res.data[_key].id,
                                    name: res.data[_key].name
                                });
                            }
                            this.showSelectFace = true;
                            this.isAllSendPerson = true;
                            this.fnGetaccessEqpt();
                        })
                            .catch(err => {
                                this.$message.error('获取全部人员失败');
                            });
                    }
                });
        },
        // 创建任务
        fnAddTask(_obj, _cb) {
            request({
                url: 'task/add',
                method: 'POST',
                data: _obj
            }).then(res => {
                _cb && _cb(res.data);
            })
                .catch(err => {
                    this.$message.error(err.data);
                });
        },
        // 获取人脸设备列表
        fnGetaccessEqpt() {
            request({
                url: 'accessEqpt/get',
                method: 'GET'
            }).then(res => {
                let _data = res.data.query;
                for (var i in _data) {
                    _data[i].selected = false;
                }
                this.faceList = _data;
            })
                .catch(err => {
                    this.$message.error(err.data);
                });
        },
        // 下发人员至客户端
        fnSendClient() {
            request({
                url: 'personnel/client_send_attendance',
                method: 'GET'
            }).then(res => {
                this.$message.success(res.data);
            })
                .catch(err => {
                    this.$message.error(err.data);
                });
        },
        // 推荐使用小程序工人自主录入
        fnShowProjectCode() {
            if (!this.userInfo.xcx_code) {
                return this.$message.warning('该项目暂无项目二维码，请联系管理人员生成项目二维码');
            }
            this.xcxQRcodeUrl = this.userInfo.xcx_code;
            this.showXcx = true;
        },
        // 全选
        fnSelectAll() {
            this.selectAll = !this.selectAll;
            if (this.selectAll) {
                for (let i = 0; i < this.tableData.length; i++) {
                    this.tableData[i].selected = true;
                }
                this.selectedSendPersonnel = this.tableData;
            } else {
                for (let i = 0; i < this.tableData.length; i++) {
                    this.tableData[i].selected = false;
                    this.selectedSendPersonnel = [];
                }
            }
        },
        // 单个选择
        fnHandleCheckedChange(_index) {
            for (let i = 0; i < this.tableData.length; i++) {
                if (i == _index) {
                    this.tableData[i].selected = !this.tableData[i].selected;
                }
            }
            let _arr = [];
            for (let j = 0; j < this.tableData.length; j++) {
                if (this.tableData[j].selected) {
                    _arr.push(this.tableData[j]);
                }
            }
            if (_arr.length == this.tableData.length) {
                this.selectAll = true;
            } else {
                this.selectAll = false;
            }
            this.selectedSendPersonnel = _arr;
        },
        // 选择下发的设备
        fnSelectAccess(val) {
            this.selectAccess = val;
        },
        // 获取上传时选中的人员信息
        handleSelectionChange(_val) {
            this.selectedUploadPersonnel = _val;
        },
        // 下发人员至人脸设备
        fnSendPersonToAccess() {
            if (!this.selectAccess.length) {
                return this.$message.warning('请选择需要下发的人脸设备');
            }
            let _data = this.selectAccess;
            if (this.isAllSendPerson) {
                // 下发全部人员时进行记录
                let _val = new Date().getTime();
                let _myDate = new Date();
                _myDate.setDate(_myDate.getDate() + 1);
                _myDate.setHours(0, 0, 0, 0); // 设置有效期为次日凌晨
                Cookies.set('isAllSendPerson', _val, {
                    expires: _myDate
                });
            }
            for (let i = 0; i < _data.length; i++) {
                this.fnAddTask({
                    name: '下发人员至设备',
                    content: '下发人员至设备,设备SN:' + _data[i].sn
                }, res => {
                    request({
                        url: (APP.isTest ? APP.HOST.TEST.TASK_DELIVER : APP.HOST.OFFICIAL.TASK_DELIVER) + '/task/deliver/',
                        method: 'POST',
                        data: {
                            eqptSN: this.selectAccess[i].sn,
                            cmd: 'sendPerson',
                            data: JSON.stringify(this.needSendPersonnel),
                            company_name: this.userInfo.name,
                            tid: res.tid
                        }
                    }).then(res => {
                        this.showSelectFace = false;

                        this.showErrorDown = true;
                    })
                        .catch(err => {
                            this.showErrorDown = true;
                            this.$message.error(err.data);
                        });
                });
            }
        },
        // 下发失败查看详情
        goToWork() {
            this.$router.push({path: '/task'});
            this.showErrorDown = false;
        },
        // 关闭上传融创人员弹窗
        fnCloseUploadRc() {
            this.showUploadRc = !this.showUploadRc
        },
        // 导出excel
        fnExportExcel() {
            let _page = 0;
            let _size = 100;
            let _countPage = Math.ceil(this.pageTotal / _size);
            let _personnelData = [];
            for (let i = 0; i < _countPage; i++) {
                ++_page;
                this.fnGetPersonnel({
                    page: _page,
                    size: _size,
                    name: this.searchName,
                    card_no: this.searchCardNo,
                    department: this.searchDepartment,
                    position: this.searchPosition,
                    idcard: this.searchId,
                    is_deleted: this.searchDelete,
                    status: this.searchStatus,
                        task_state: this.searchTaskState,
                    create_at: this.searchCreateDate ? this.searchCreateDate.join(',') : ''
                }, res => {
                    _personnelData = _personnelData.concat(res.data.query);
                    _countPage = Math.ceil(res.data.count / _size);
                    if (_personnelData.length == res.data.count) {
                        let _excelData = [];
                        _personnelData.forEach(_item => {
                            let _extend = _item.extend ? JSON.parse(_item.extend) : {};
                            let _validity = _item.validity_period;
                            let _start_validity = _validity ? _item.validity_period.split('-')[0] : _validity;
                            let _end_validity = _validity ? _item.validity_period.split('-')[1] : _validity;
                            _excelData.push({
                                id: _item.id,
                                name: _item.name,
                                sex: _item.sex === APP.YES ? '男' : '女',
                                card_no: _item.card_no,
                                department: APP.fnPositionToText(_item.department).text,
                                position: APP.fnPositionToText(_item.position).text,
                                phone: _item.phone,
                                idcard: _extend.card_id || _item.idcard,
                                nation: _item.nation,
                                birthday: _item.birthday,
                                address: _item.address,
                                cert_org: _item.cert_org,
                                start_validity: APP.fnDateAddEm_public(_start_validity),
                                end_validity: APP.fnDateAddEm_public(_end_validity)
                            });
                        });
                        const {export_json_to_excel} = require('../../../vendor/Export2Excel.js');
                        const tHeader = ['卡号', '姓名', '性别', '民族', '身份证号', '有效起始日期', '有效截止日期', '发证机关', '班组', '工种', '手机号码', '出生日期', '住址'];
                        const filterVal = [
                            'card_no',
                            'name',
                            'sex',
                            'nation',
                            'idcard',
                            'start_validity',
                            'end_validity',
                            'cert_org',
                            'department',
                            'position',
                            'phone',
                            'birthday',
                            'address'
                        ];
                        const data = APP.formatJson(filterVal, _excelData);
                        const _filename = getUserInfo().name + '-' + new Date().Format('yyyy-MM-dd') + '人员列表';
                        export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: _filename
                        });
                    }
                });
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import '@/styles/mixin.scss';

.person_box {
    width: 1920px;
    height: 858px;
    position: relative;
    overflow: hidden;

    .person {
        position: absolute;
        left: 0;
        right: -20px;
        top: 0;
        bottom: 0;
        overflow-x: hidden;
        overflow-y: auto;
    }
}

.search_box {
    height: 148px;
    width: 1880px;
    margin-top: 24px;
    margin-left: 20px;
    @include flex-box(space-between, center, column);

    .box_line {
        width: 1880px;
        height: 32px;
        @include flex-box(flex-start, center);

        .line_input {
            min-width: 280px;
            height: 30px;
            margin-right: 10px;
            border-top-right-radius: 1px;
            border-bottom-right-radius: 1px;
            background-color: rgba(49, 88, 128, 0.4);
            @include flex-box(flex-start, center);

            .input_title {
                width: 69px;
                height: 30px;
                font-size: 14px;
                color: #9bf9fc;
                border-radius: 2px;
                background-color: rgba(155, 249, 252, 0.1);
                @include flex-box(center, center);
            }

            .input_box {
                width: 211px;
                height: 30px;
                line-height: 30px;
                padding-left: 15px;
                color: rgba(77, 180, 244, 0.7);
                font-size: 12px;
                border-radius: 2px;
                outline: none;
                background: transparent;
                border: none;

                &::-webkit-input-placeholder {
                    color: rgba(77, 180, 244, 0.7);
                }

                &::-moz-placeholder {
                    /* Mozilla Firefox 19+ */
                    color: rgba(77, 180, 244, 0.7);
                }

                &:-moz-placeholder {
                    /* Mozilla Firefox 4 to 18 */
                    color: rgba(77, 180, 244, 0.7);
                }

                &:-ms-input-placeholder {
                    /* Internet Explorer 10-11 */
                    color: rgba(77, 180, 244, 0.7);
                }
            }

            .select_box {
                width: 211px;
                height: 30px;
                border-radius: 2px;
            }
        }

        .add_person {
            width: 106px;
            height: 32px;
            margin-right: 5px;
            cursor: pointer;
            background: url(../../../assets/img/per_list_add.png) no-repeat;
            background-size: 100% 100%;
        }

        .to_face {
            width: 159px;
            height: 32px;
            margin-right: 5px;
            cursor: pointer;
            background: url(../../../assets/img/per_btn_toaccess.png) no-repeat;
            background-size: 100% 100%;
        }

        .to_custom {
            width: 159px;
            height: 32px;
            margin-right: 5px;
            cursor: pointer;
            background: url(../../../assets/img/per_btn_tocustom.png) no-repeat;
            background-size: 100% 100%;
        }

        .to_export {
            width: 106px;
            height: 32px;
            margin-right: 5px;
            cursor: pointer;
            background: url(../../../assets/img/per_btn_export.png) no-repeat;
            background-size: 100% 100%;
        }

        .to_weixin {
            width: 216px;
            height: 32px;
            cursor: pointer;
            background: url(../../../assets/img/per_btn_toweixin.png) no-repeat;
            background-size: 100% 100%;
        }

        .to_upload {
            width: 159px;
            height: 32px;
            margin-right: 5px;
            cursor: pointer;
            background: url(../../../assets/img/per_btn_toupload.png) no-repeat;
            background-size: 100% 100%;
        }
    }
}

.cont_list {
    margin-top: 29px;
    margin-left: 28px;
    width: 1864px;
    height: 561px;
    border-radius: 10px;
    background-color: rgba(29, 68, 149, 0.1);

    .list_title {
        width: 1864px;
        height: 48px;
        background: url(../../../assets/img/per_list_bg.png) no-repeat;
        background-size: 100% 100%;
        @include flex-box(flex-start, center);

        .title_item {
            width: 50px;
            height: 48px;
            @include flex-box(center, center);

            &:nth-child(1) {
                margin-right: 4px;
                margin-left: 40px;
            }

            &:nth-child(2) {
                width: 96px;
                margin-right: 4px;
            }

            &:nth-child(3) {
                width: 126px;
                margin-right: 4px;
            }

            &:nth-child(4) {
                width: 86px;
                margin-right: 4px;
            }

            &:nth-child(5) {
                width: 176px;
                margin-right: 4px;
            }

            &:nth-child(6) {
                width: 136px;
                margin-right: 4px;
            }

            &:nth-child(7) {
                width: 136px;
                margin-right: 4px;
            }

            &:nth-child(8) {
                width: 136px;
                margin-right: 4px;
            }

            &:nth-child(9) {
                width: 106px;
                margin-right: 4px;
            }

            &:nth-child(10) {
                width: 106px;
                margin-right: 4px;
            }

            &:nth-child(11) {
                width: 126px;
                margin-right: 4px;
            }

            &:nth-child(12) {
                width: 206px;
                margin-right: 4px;
            }

            &:nth-child(13) {
                width: 250px;
            }

            .select {
                width: 20px;
                height: 20px;
                border: 1px solid #65a6dd;
                border-radius: 2px;
                cursor: pointer;
                @include prefixCss3(transition, border-color 0.2s);

                &:hover {
                    border-color: #409eff;
                }

                &.active {
                    background-color: #409eff;
                    border-color: #409eff;

                    &::after {
                        content: '';
                        display: block;
                        width: 100%;
                        height: 100%;
                        @include set-bg-img('../../../assets/images/icon-yes.png');
                    }
                }
            }
        }
    }

    .list_boxes {
        width: 1864px;
        height: 513px;
        position: relative;
        overflow: hidden;

        .list_box {
            position: absolute;
            left: 0;
            right: -25px;
            top: 0;
            bottom: 0;
            overflow-x: hidden;
            overflow-y: auto;

            .box_line {
                width: 1784px;
                height: 70px;
                margin: 7px 0 0 40px;
                font-size: 16px;
                color: #ffffff;
                border-bottom: 1px dashed #1d4495;
                @include flex-box(flex-start, center);

                &:hover {
                    background-color: rgba(49, 88, 128, 0.4);
                }

                .list_item {
                    width: 50px;
                    height: 70px;
                    text-align: center;
                    @include flex-box(center, center);

                    &:nth-child(1) {
                        margin-right: 4px;
                    }

                    &:nth-child(2) {
                        width: 96px;
                        margin-right: 4px;
                    }

                    &:nth-child(3) {
                        width: 126px;
                        margin-right: 4px;
                    }

                    &:nth-child(4) {
                        width: 86px;
                        margin-right: 4px;
                    }

                    &:nth-child(5) {
                        width: 176px;
                        margin-right: 4px;
                    }

                    &:nth-child(6) {
                        width: 136px;
                        margin-right: 4px;
                    }

                    &:nth-child(7) {
                        width: 136px;
                        margin-right: 4px;
                    }

                    &:nth-child(8) {
                        width: 136px;
                        margin-right: 4px;
                    }

                    &:nth-child(9) {
                        width: 106px;
                        margin-right: 4px;
                    }

                    &:nth-child(10) {
                        width: 106px;
                        margin-right: 4px;
                    }

                    &:nth-child(11) {
                        width: 126px;
                        margin-right: 4px;
                    }

                    &:nth-child(12) {
                        width: 206px;
                        margin-right: 4px;
                    }

                    &:nth-child(13) {
                        width: 250px;
                    }

                    img {
                        width: 60px;
                        height: 60px;
                        border-radius: 50%;
                    }

                    &.green-c {
                        color: #89d340;
                    }

                    &.red-c {
                        color: #df7475;
                    }

                    div {
                        @include flex-box(center, center);

                        .item_btn {
                            width: 50px;
                            height: 32px;
                            line-height: 32px;
                            margin: 0 2px;
                            font-size: 14px;
                            color: #ffffff;
                            border: none;
                            cursor: pointer;
                            @include flex-box(center, center);

                            &.blue {
                                background: url(../../../assets/img/btn_bg_bsm.png) no-repeat;
                                background-size: 100% 100%;
                            }

                            &.yellow {
                                background: url(../../../assets/img/btn_bg_osm.png) no-repeat;
                                background-size: 100% 100%;
                            }

                            &.red {
                                background: url(../../../assets/img/btn_bg_rsm.png) no-repeat;
                                background-size: 100% 100%;
                            }

                            &.green {
                                background: url(../../../assets/img/per_bg_g.png) no-repeat;
                                background-size: 100% 100%;
                            }

                            span {
                                margin-top: -2px;
                            }
                        }
                    }

                    span {
                        width: 100%;
                        cursor: pointer;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }

                    .select {
                        width: 20px;
                        height: 20px;
                        border: 1px solid #65a6dd;
                        border-radius: 2px;
                        cursor: pointer;
                        @include prefixCss3(transition, border-color 0.2s);

                        &:hover {
                            border-color: #409eff;
                        }

                        &.active {
                            background-color: #409eff;
                            border-color: #409eff;

                            &::after {
                                content: '';
                                display: block;
                                width: 100%;
                                height: 100%;
                                @include set-bg-img('../../../assets/images/icon-yes.png');
                            }
                        }
                    }
                }
            }
        }
    }
}

.box_line {
    > > > .el-input__inner {
        width: 211px;
        height: 30px;
        border-radius: 2px;
        border: none;
        color: rgba(77, 180, 244, 0.7);
        background: transparent;

        &::-webkit-input-placeholder {
            color: rgba(77, 180, 244, 0.7);
        }

        &::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: rgba(77, 180, 244, 0.7);
        }

        &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: rgba(77, 180, 244, 0.7);
        }

        &:-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: rgba(77, 180, 244, 0.7);
        }
    }

    > > > .el-select__caret {
        color: rgba(77, 180, 244, 0.7);
    }

    > > > .el-select-dropdown {
        background-color: rgba(9, 17, 32, 1);
        border: 1px solid rgba(77, 180, 244, 1);
    }

    > > > .popper__arrow {
        border-bottom-color: rgba(77, 180, 244, 1) !important;
    }

    > > > .el-select-dropdown__item {
        color: rgba(77, 180, 244, 0.7);
    }

    > > > .el-select-dropdown__item:hover {
        color: #409eff;
    }

    > > > .el-select-dropdown__item.hover {
        color: #409eff;
    }

    > > > .el-input__icon {
        color: rgba(77, 180, 244, 0.7);
    }

    > > > .el-range-input {
        color: rgba(77, 180, 244, 0.7);
        background: transparent;

        &::-webkit-input-placeholder {
            color: rgba(77, 180, 244, 0.7);
        }

        &::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: rgba(77, 180, 244, 0.7);
        }

        &:-moz-placeholder {
            /* Mozilla Firefox 4 to 18 */
            color: rgba(77, 180, 244, 0.7);
        }

        &:-ms-input-placeholder {
            /* Internet Explorer 10-11 */
            color: rgba(77, 180, 244, 0.7);
        }
    }

    > > > .el-range-separator {
        color: rgba(77, 180, 244, 0.7);
    }
}

.dialog_perXcx, .dialog_choose, .dialog_toAccessError {
    .btn_line {
        @include flex-box(center, center);
    }

    > > > .el-dialog {
        background-color: rgba(9, 17, 32, 1);
        border: 1px solid rgba(58, 116, 221, 1);

        .row-item {
            color: white;
        }
    }

    > > > .el-form-item__label {
        color: #4db4f4;
    }

    > > > .el-dialog__title {
        color: #4db4f4;
    }

    > > > .el-dialog__close {
        color: #4db4f4;
    }
}

.dialog_choose {
    > > > .el-dialog {
        width: 910px;
        height: 600px;
    }

    .cont_list {
        width: 860px;
        height: 425px;
        color: #ffffff;
        font-size: 16px;
        border-radius: 10px;
        margin: 0;
        background-color: rgba(29, 68, 149, 0.1);

        .list_title {
            width: 860px;
            height: 48px;
            background: url(../../../assets/img/per_list_bg.png) no-repeat;
            background-size: 100% 100%;
            @include flex-box(flex-start, center);

            .title_item {
                height: 48px;
                @include flex-box(center, center);

                &:nth-child(1) {
                    width: 60px;
                    margin: 0 4px 0 30px;
                }

                &:nth-child(2) {
                    width: 250px;
                    margin-right: 4px;
                }

                &:nth-child(3) {
                    width: 159px;
                    margin-right: 4px;
                }

                &:nth-child(4) {
                    width: 159px;
                    margin-right: 4px;
                }

                &:nth-child(5) {
                    width: 160px;
                    margin-right: 30px;
                }

                .select {
                    width: 20px;
                    height: 20px;
                    border: 1px solid #65a6dd;
                    border-radius: 2px;
                    cursor: pointer;
                    @include prefixCss3(transition, border-color 0.2s);

                    &:hover {
                        border-color: #409eff;
                    }

                    &.active {
                        background-color: #409eff;
                        border-color: #409eff;

                        &::after {
                            content: '';
                            display: block;
                            width: 100%;
                            height: 100%;
                            @include set-bg-img('../../../assets/images/icon-yes.png');
                        }
                    }
                }
            }
        }

        .list_boxes {
            width: 800px;
            height: 302px;
            margin-left: 30px;
            position: relative;
            overflow: hidden;

            .list_box {
                position: absolute;
                left: 0;
                right: -25px;
                top: 0;
                bottom: 0;
                overflow-x: hidden;
                overflow-y: auto;

                .box_line {
                    width: 800px;
                    height: 70px;
                    margin: 5px 0 0 0px;
                    border-bottom: 1px dashed #1d4495;
                    @include flex-box(flex-start, center);

                    &:hover {
                        background-color: rgba(49, 88, 128, 0.4);
                    }

                    .list_item {
                        height: 70px;
                        text-align: center;
                        @include flex-box(center, center);

                        &:nth-child(1) {
                            width: 60px;
                            margin-right: 4px;
                        }

                        &:nth-child(2) {
                            width: 250px;
                            margin-right: 4px;
                        }

                        &:nth-child(3) {
                            width: 159px;
                            margin-right: 4px;
                        }

                        &:nth-child(4) {
                            width: 159px;
                            margin-right: 4px;
                        }

                        &:nth-child(5) {
                            width: 160px;
                        }

                        .select {
                            width: 20px;
                            height: 20px;
                            border: 1px solid #65a6dd;
                            border-radius: 2px;
                            cursor: pointer;
                            @include prefixCss3(transition, border-color 0.2s);

                            &:hover {
                                border-color: #409eff;
                            }

                            &.active {
                                background-color: #409eff;
                                border-color: #409eff;

                                &::after {
                                    content: '';
                                    display: block;
                                    width: 100%;
                                    height: 100%;
                                    @include set-bg-img('../../../assets/images/icon-yes.png');
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

.dialog_perXcx {
    > > > .el-dialog {
        width: 510px;
        height: 720px;
        margin-top: 20vh !important;
    }

    img {
        width: 460px;
    }
}

.dialog_toAccessError {
    > > > .el-dialog {
        width: 500px;
        height: 200px;
        margin-top: 40vh !important;
    }

    div {
        width: 100%;
        text-align: center;
        color: rgba(255, 255, 255, 0.8);
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Person/personCt/index.vue